import { FileMultiValuedList } from '../../../File'
import { ListCell } from '../ListCell'

function TableFileListCell({ List = FileMultiValuedList, ...restProps }) {
  return <ListCell {...restProps} List={List} />
}

export default TableFileListCell
